// DivingPage.jsx
import React from 'react';
import { useTranslation } from 'react-i18next'; // Important
import { motion } from 'framer-motion';
import divingImage from '../assets/Diving/135-1024x679-1.jpg';
import coralReefImage from '../assets/Diving/db.jpg';
import shipwreckImage from '../assets/Diving/Diving_Weligama.jpg';

const DivingPage = () => {
    const { t } = useTranslation('diving'); // Using 'diving' namespace

    return (
        <div className="bg-[#001F3F] py-10">
            <div className="container mx-auto px-4">
                {/* Page Title */}
                <h1 className="text-center text-4xl md:text-5xl lg:text-6xl font-bold font-konkhmer mb-16 text-[#7FDBFF]">
                    {t('title')}
                </h1>

                {/* Main Content: Image + Text */}
                <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-center">
                    {/* Left: Main Image */}
                    <div className="w-full lg:w-1/3">
                        <motion.div
                            whileHover={{ scale: 1.03 }}
                            className="group relative overflow-hidden rounded-2xl shadow-2xl"
                        >
                            <img
                                src={divingImage}
                                alt={t('mainImageAlt')}
                                className="w-full h-auto max-h-[500px] object-cover transition-transform duration-500 group-hover:scale-110"
                                loading="lazy"
                            />
                            <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-6">
                                <p className="text-white text-lg font-semibold">{t('mainImageCaption')}</p>
                            </div>
                        </motion.div>
                    </div>

                    {/* Right: Text Content */}
                    <div className="w-full lg:w-2/3 space-y-8 text-white font-inknut">
                        <p className="text-base md:text-lg lg:text-xl leading-relaxed">
                            {t('introParagraph1')}
                        </p>
                        <p className="text-base md:text-lg lg:text-xl leading-relaxed">
                            {t('introParagraph2')}
                        </p>
                    </div>
                </div>

                {/* Facilities Section */}
                <div className="mt-16">
                    <h2 className="text-center text-4xl md:text-5xl lg:text-6xl font-bold font-konkhmer mb-10 text-[#7FDBFF]">
                        {t('facilitiesTitle')}
                    </h2>

                    <div className="bg-white rounded-2xl p-8 md:p-12 shadow-2xl">
                        <p className="text-gray-800 text-base md:text-lg lg:text-xl leading-relaxed font-inknut mb-6">
                            {t('facilitiesParagraph1')}
                        </p>
                        <p className="text-gray-800 text-base md:text-lg lg:text-xl leading-relaxed font-inknut">
                            {t('facilitiesParagraph2')}
                        </p>
                    </div>
                </div>

                {/* Additional Images */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-16">
                    <motion.div
                        whileHover={{ scale: 1.03 }}
                        className="group relative overflow-hidden rounded-2xl shadow-2xl"
                    >
                        <img
                            src={coralReefImage}
                            alt={t('coralImageAlt')}
                            className="w-full h-80 md:h-96 object-cover transition-transform duration-500 group-hover:scale-110"
                            loading="lazy"
                        />
                        <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-6">
                            <p className="text-white text-lg font-semibold">{t('coralImageCaption')}</p>
                        </div>
                    </motion.div>

                    <motion.div
                        whileHover={{ scale: 1.03 }}
                        className="group relative overflow-hidden rounded-2xl shadow-2xl"
                    >
                        <img
                            src={shipwreckImage}
                            alt={t('shipwreckImageAlt')}
                            className="w-full h-80 md:h-96 object-cover transition-transform duration-500 group-hover:scale-110"
                            loading="lazy"
                        />
                        <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-6">
                            <p className="text-white text-lg font-semibold">{t('shipwreckImageCaption')}</p>
                        </div>
                    </motion.div>
                </div>

                {/* Tips Section */}
                <div className="mt-16">
                    <h2 className="text-center text-4xl md:text-5xl lg:text-6xl font-bold font-konkhmer mb-10 text-[#7FDBFF]">
                        {t('tipsTitle')}
                    </h2>

                    <div className="bg-white rounded-2xl p-8 md:p-12 shadow-2xl">
                        <ul className="space-y-4 text-gray-800 text-base md:text-lg lg:text-xl font-inknut">
                            <li className="flex items-start">
                                <span className="text-[#0074D9] mr-3">•</span>
                                <span>{t('tip1')}</span>
                            </li>
                            <li className="flex items-start">
                                <span className="text-[#0074D9] mr-3">•</span>
                                <span>{t('tip2')}</span>
                            </li>
                            <li className="flex items-start">
                                <span className="text-[#0074D9] mr-3">•</span>
                                <span>{t('tip3')}</span>
                            </li>
                            <li className="flex items-start">
                                <span className="text-[#0074D9] mr-3">•</span>
                                <span>{t('tip4')}</span>
                            </li>
                            <li className="flex items-start">
                                <span className="text-[#0074D9] mr-3">•</span>
                                <span>{t('tip5')}</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DivingPage;